module.exports = __webpack_public_path__ + "static/media/review-image-anniinal.429bfa18.png";